import { Component, OnInit } from '@angular/core';
import {AuthService} from "../shared/auth.service";
import {Router} from "@angular/router";
import {TranslateService} from "@ngx-translate/core";
import {NbToastrService} from "@nebular/theme";

@Component({
    selector: 'bst-logout',
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})
export class LogoutComponent implements OnInit {

  constructor(private auth: AuthService,
              private translate: TranslateService,
              private toast: NbToastrService,
              private router: Router) {

  }

  ngOnInit(): void {
    this.auth.logout().finally(() => {
      return this.translate.get(['loggedout', 'success']).toPromise().then(info => {
        this.toast.info(info.loggedout, info.success, {
          duration: 5000,
          icon: 'log-out'
        });
        return this.router.navigateByUrl("/login");
      });
    });
  }

}
